var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "check_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23 11.938l5.5-5.48a.68.68 0 01.52-.218.758.758 0 01.52.24c.154.152.23.326.23.52a.718.718 0 01-.23.52l-6 6a.729.729 0 01-1.062 0L5.23 11.043A.718.718 0 015 10.52c0-.195.076-.368.23-.521a.718.718 0 01.52-.23c.194 0 .368.077.52.23l1.96 1.938z",
    fill: "#1C1B1F"
  }))));
}
export default SvgCheck;